document.addEventListener('DOMContentLoaded', () => {
    const galleryThumbs = new Swiper(".gallery-thumbs", {
      loop: true,
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        750: {
          direction: "vertical",
          slidesPerView: "auto",
        }
      }
    });
  
    const galleryTop = new Swiper(".gallery-top", {
      loop: true,
      direction: "horizontal",
      spaceBetween: 0,
      navigation: {
        nextEl: document.querySelector('[class*="swiper-button-next"]'),
        prevEl: document.querySelector('[class*="swiper-button-prev"]'),
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      keyboard: {
        enabled: true,
      },
      thumbs: {
        swiper: galleryThumbs
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  });
  